import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h3, h4, paragraphMedium } from '@helpers/typography';
import CalloutCardStyles from '@stories/Components/Cards/CalloutCard/CalloutCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background-color: var(--bgColor);

  &[data-variant='white'] {
    --bgColor: ${brand.white};
  }

  &[data-variant='blue'] {
    --bgColor: ${brand.secondary.blueGrey};
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid}
    column-gap: 16px;
    row-gap: 20px;
    grid-template-columns: repeat(12, 1fr);
  }

  ${CalloutCardStyles.Container} {
    grid-column: span 12;

    @media ${from(Device.MobileLarge)} {
      grid-column: span 6;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: span 4;
    }
  }

  @media ${from(Device.Desktop)} {
    &[data-cols='2'] {
      ${CalloutCardStyles.Container} {
        grid-column: span 6;
      }
    }
  }
  @media ${from(Device.Desktop)} {
    &[data-cols='4'] {
      ${CalloutCardStyles.Container} {
        grid-column: span 3;
      }
    }
  }
`;
const TitleWrapper = styled.div `
  grid-column: span 12;
  &[data-split='true'] {
    @media ${from(Device.TabletLarge)} {
      display: grid;
      grid-template-columns: 0.9fr 1.1fr;
      gap: ${fluid(40, 90)};
      place-items: flex-start;
    }
  }
`;
const Title = styled.h2 `
  ${h4};

  margin-bottom: ${fluid(20, 45)} !important;

  h1& {
    ${h3};
  }

  [data-split='false'] & {
    text-align: center;
  }
`;
const Content = styled.div `
  padding-top: 8px;

  p {
    ${paragraphMedium}

    @media ${from(Device.DesktopLarge)} {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;
const CalloutCardsStyles = {
    Container,
    Content,
    Title,
    TitleWrapper,
};
export default CalloutCardsStyles;
